var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-image',{attrs:{"src":_vm.src,"fallback-src":_vm.avatarMixinDefaultGroupAvatar,"alt":_vm.alt,"image-class":_vm.imageClass}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a4683b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/image/BaseAvatarImage.vue
// module id = null
// module chunks = 